import { render } from "./index.vue?vue&type=template&id=ae2e3e1a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ae2e3e1a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script